export const customStyles = {
    control: (provided, state) => ({
        ...provided, backgroundColor: '#212529', borderColor: state.isFocused ? '#b7343a' : '#495057', color: '#fff',
        minHeight: '45px', boxShadow: state.isFocused ? '0 0 0 1px #b7343a' : 'none', '&:hover': { borderColor: '#b7343a' }
    }),
    singleValue: (p) => ({ ...p, color: '#fff' }),
    input: (p) => ({ ...p, color: '#fff', margin: 0, padding: 0 }),
    menu: (p) => ({ ...p, backgroundColor: '#212529', zIndex: 9999, border: '1px solid #495057' }),
    option: (p, state) => ({
        ...p, backgroundColor: state.isSelected ? '#b7343a' : state.isFocused ? '#343a40' : '#212529',
        color: '#fff', cursor: 'pointer', '&:active': { backgroundColor: '#b7343a' }
    }),
    multiValue: (p) => ({ ...p, backgroundColor: '#343a40' }),
    multiValueLabel: (p) => ({ ...p, color: '#fff' }),
    multiValueRemove: (p) => ({ ...p, color: '#fff', ':hover': { backgroundColor: '#b7343a', color: 'white' } }),
};

export const transformToSelectOptions = (arr) => {
    if (!arr || !Array.isArray(arr)) return [];
    return arr.map(item => ({ value: item.lookupValue, label: item.lookupLabel }));
};